module.exports = __webpack_public_path__ + "static/ada1-a54e7c18f03f07f12c012d015eda8a26.jpg";